<template>
    <div v-if="iconsStatus.icon === 'survey'">
        <div v-if="appStatus.displayInAppsNotification" class="notificationBarWrapper" @click="() => openAdHocQuestionPage()">
            <IconNotifSurvey></IconNotifSurvey>
            <p class="notificationFont"> {{iconsStatus.textCollapsed}} </p>
        </div>
    </div>
    <div v-else>
        <div v-if="appStatus.displayInAppsNotification" class="notificationBarWrapper" @click="() => openNotificationPage()">
            <div v-if="iconsStatus.icon === 'action'">
                <IconNotifAction></IconNotifAction>
            </div>
            <div v-if="iconsStatus.icon === 'celebration'">
                <IconNotifCelebration></IconNotifCelebration>
            </div>
            <p class="notificationFont"> {{iconsStatus.textCollapsed}} </p>
        </div>
        <div v-else>
        </div>
    </div>
</template>

<script setup lang="ts">


import { reactive, onUpdated, onMounted, onUnmounted, watch } from "vue";
import { useRouter } from 'vue-router';
import IconNotifAction from "../../components/icons/IconNotifAction.vue" // eslint-disable-line no-unused-vars
import IconNotifSurvey from "../../components/icons/IconNotifSurvey.vue" // eslint-disable-line no-unused-vars
import IconNotifCelebration from "../../components/icons/IconNotifCelebration.vue" // eslint-disable-line no-unused-vars
import { appStatus } from '../../use/useAppStatus';   
import { useLocalNotificatiSync } from '../../use/useLocalNotificatiSync';


/*
  declarations
*/
const router = useRouter();

var iconsStatus = reactive({
  icon: "",
  textCollapsed: "",
  textExpanded: ""
});

let notificationCheckInterval: ReturnType<typeof setInterval> | null = null;

onUpdated(() => {
    console.log("NotificationBar.vue onUpdated");
});

const refreshNotificationBar = () => {
    var notifData = localStorage.getItem("notificationData");
    if (notifData != null && notifData.length > 0 && notifData != '[]') {
        const unseenNotifications = JSON.parse(notifData).filter((notification: any) => !notification.viewed && Date.now() > notification.time);
        if (unseenNotifications.length > 0) {
            const latestNotification = unseenNotifications[unseenNotifications.length - 1];
            iconsStatus.icon = latestNotification.icon;
            iconsStatus.textCollapsed = latestNotification.textCollapsed;
            iconsStatus.textExpanded = latestNotification.textExpanded;
            appStatus.displayInAppsNotification = true;
        } else {
            appStatus.displayInAppsNotification = false;
        }
    }
}

onMounted(() => {

    // check notifications every 60 seconds
    notificationCheckInterval = setInterval(refreshNotificationBar, 60000);

    // refresh notification bar when localStorage is updated, 
    // for example when user click on notification in the notification center
    const handleStorageEvent = (event: StorageEvent) => {
        if (event.key === 'notificationData') {
            console.log("NotificationBar.vue storage event");
            refreshNotificationBar();
        }
    };
    window.addEventListener('storage', handleStorageEvent);
    onUnmounted(() => {
        window.removeEventListener('storage', handleStorageEvent);
        if (notificationCheckInterval !== null) {
            clearInterval(notificationCheckInterval);
        }
    });

    // refresh notification bar when component is mounted
    refreshNotificationBar();
});

// using watch to update the notification bar when notification is trigger on same route
watch(appStatus.notificationList, () => {
    console.log("NotificationBar.vue watch");
    refreshNotificationBar();
});

function openNotificationPage() {

    //[todo] need to update the notification data to display false, so that the notification will not be display again. need to handle older notification is true but latest is false issue
    var notifData = localStorage.getItem("notificationData");
    if(notifData != null){
        var parsedata = JSON.parse(notifData) 
        parsedata[parsedata.length-1].viewed = true; 
        parsedata[parsedata.length-1].display = true;
        useLocalNotificatiSync().UpdateInAppNotifViewedStatus(parsedata[parsedata.length-1].back_end_id);
        localStorage.setItem("notificationData", JSON.stringify(parsedata));
    }

    appStatus.displayInAppsNotification = false; 
    router.push({name: 'notifications'});
}

async function openAdHocQuestionPage() {

    let adHocShow = false;
    const notifData = localStorage.getItem("notificationData");
    if (notifData !== null) {
        for (let i = 0; i < JSON.parse(notifData).length; i++) {
        if (JSON.parse(notifData)[i].type === "adHoc") {
            console.log("adHocStorage");
            adHocShow = true;
            break;
        }
        }

        if(!adHocShow){
            var parsedata = JSON.parse(notifData) 
            parsedata[parsedata.length-1].viewed = true; 
            parsedata[parsedata.length-1].display = true;
            // update in-app notification viewed status to database
            useLocalNotificatiSync().UpdateInAppNotifViewedStatus(parsedata[parsedata.length-1].back_end_id);
            localStorage.setItem("notificationData", JSON.stringify(parsedata));
        }
    }

    appStatus.displayInAppsNotification = false; 
    router.push({name: 'notifications'});
}

//[todo] push notification work in progress
//[todo] if trigger InAppsNotification subscription will be replace and we need to update the subscription to server again. more testing needed!
/* eslint-disable */
function triggerInAppsNotification() {
    if ('PushManager' in window) {
        const options = {
            body: 'Your notification message',
            icon: 'img/icons/apple-touch-icon-60x60.png', 
            image: 'img/icons/apple-touch-icon-120x120.png', 
        };

        navigator.serviceWorker.ready.then(registration => {

            registration.pushManager.getSubscription().then(subscription => {
                console.log(JSON.stringify(subscription));
            if (subscription) {
                // Send a push message
                registration.showNotification('TouchPoints', options);
                
            } else {
                // User is not subscribed to push notifications
                console.log('User is not subscribed');
            }
            });
        });
    }
}
/* eslint-enable */

</script>

<style scoped>
.notificationBarWrapper{
    height: 50px;
    display: flex;
    align-content: center;
    align-items: center;
    cursor: pointer;
    /* background-color: #655A95; */
}
.notificationFont{
  padding-left: 10px;
  font-family: Karla, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  --color: #000000;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.48px;
}

</style>